import React from 'react'
import ListingPageWithRoutes from 'containers/ListingPage/listingRouter'
import X4ULayoutForm from './Form'
import {
  OMNI_JOURNEY_MENU,
  tableProperties,
} from 'components/OmniJourney/utils'
import { getMessage } from 'lib/translator'
import { Link } from 'react-router-dom'
import './style.scss'

const linkButtons = () => {
  return (
    <div className="header-wrap">
      <Link to="/omni-journey/x4u-layout/add">
        <button className="primary button">
          <span className="text">
            {getMessage('omni-journey.create.x4u-layout')}
          </span>
        </button>
      </Link>
    </div>
  )
}

const HEADERS = ['ID', 'Profile', 'Start Date', 'End Date', 'Status', 'Actions']

const ManageX4ULayout = (props) => {
  return (
    <ListingPageWithRoutes
      title="Manage X4U Layout"
      addHeading="Create Profile"
      editHeading="Edit Profile"
      viewHeading="Profile Details"
      menu={props.menu}
      className="x4u-layout-listing"
      api={{
        url: `/genie/lms/content`,
        transform: (res) => {
          return res.data.items
        },
        params: {
          contentType: 'scan',
          key: 'layout#profile',
          sk: props.match.params.sk,
        },
      }}
      headerActions={linkButtons}
      emptyState={{ actions: linkButtons }}
      tableProperties={tableProperties(OMNI_JOURNEY_MENU[2], HEADERS)}
      form={{
        component: X4ULayoutForm,
      }}
      dontSavePagination
      primaryKey="sk"
      tableDynamic
    />
  )
}

export default ManageX4ULayout
